export const defaultLocale = 'en-US';

/**
 * This is the "invisible comma" character - we want a delimiter that is uncommon in text and not
 * searchable with typical terms. Note it's wrapped in whitespace to allow for accurate tokenization
 * of surrounding words.
 */

export const delimiter = ` ${String.fromCharCode(8291)} `;
